<template>
  <div class="PastStrategyOptions">
    <MobileNav :page_title="nav_title"></MobileNav>

    <div class="PastStrategyOptionsContainer">
      <div class="desktopFilterSection">
        <!-- sent filter_list as props to desktop filter component to display filters by page type -->
        <FilterForDesktopViewDerivatives :filter_title="filter_title" :filter_list="filter_list" user_type="expert">
        </FilterForDesktopViewDerivatives>
      </div>

      <div class="search-container">
        <div class="search-stock-section">
          <search-stock class="search-stock-component"></search-stock>

          <div class="export-section flex-center" v-if="
            (userProfile && userProfile.mark_as_verified_user) ||
            publisherPlaData.plan == 'Publisher'
          ">
            <div>
              <el-popover placement="bottom" title="Sort By Duration" width="225" trigger="click"
                content="Aggregated price estimates of users (only for short term)">
                <div class="top-margin-15">
                  <label class="input-label-gray" style="font-size: 11px">
                    From</label>
                  <el-date-picker v-model="startDate" type="date" placeholder="Start Date" size="mini"
                    format="dd-MM-yyyy" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </div>
                <div class="top-margin-15 bottom-margin-15">
                  <label class="input-label-gray" style="font-size: 11px">To</label>
                  <el-date-picker v-model="endDate" type="date" placeholder="End Date" size="mini" format="dd-MM-yyyy"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </div>
                <div slot="reference" class="filter-icon ">
                  <img class="cursor-pointer" src="../assets/images/Filter Icon.svg" alt width="15px" />
                </div>
              </el-popover>
            </div>
            <el-button class="download-btn export-btn flex" style="" @click="getDataForDownloadExcel()"
              :disabled="startDate == null || endDate == null" :loading="isExcelDataLoading">
              <span style="position: relative; top: -2px;">
                Export
              </span>
              <i class="el-icon-document" style="font-size: 20px; margin-left: 3px;"></i>
            </el-button>
          </div>
        </div>
      </div>

      <div class="recoListSection">
        <div v-if="!is_reco_list_loading && !other_expert_past_reco_list.length">
          <NoDataFound></NoDataFound>
        </div>

        <div class="stock-data-section">
          <OptionStrategyCard :recommendationsList="other_expert_past_reco_list" @getByExpertName="getRecoByExpertName"
            @getByStockName="getRecoByStockName" @openStockWidget="openStockWidget"></OptionStrategyCard>
        </div>

        <!-- btn to load more recos -->
        <div class="show-more-tab" v-if="this.number_of_pages > this.page_no && !is_reco_list_loading"
          @click="loadMoreRecommendations()">
          Load more
        </div>
        <div :class="{ 'infinite-loader-top-position': page_no == 1 }" v-if="is_reco_list_loading">
          <div class="text-center">
            <img src="../assets/images/company/loader.svg" style="height: 80px; width: 80px" />
            <p>Please wait, page is loading. . .</p>
          </div>
        </div>
      </div>
    </div>

    <!-- video dialog -->
    <div id="video-section">
      <el-dialog :visible.sync="videoDialog" :before-close="videoDialogClose" center>
        <iframe id="videoId" width="100%" height="600px" :src="activeVideo" title="YouTube video player" frameborder="0"
          allowscriptaccess="always"
          allow="accelerometer; autoplay:true; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </el-dialog>
    </div>

    <!-- filters for mobile view -->
    <!-- isDesktop return true if window size is 1197px other wise false -->
    <StockFilter v-if="!isDesktop" :filter_title="filter_title" :filter_list="filter_list" user_type="expert"
      class="nav-filter-icon"></StockFilter>

    <el-dialog custom-class="stock-widget-dialog" :visible.sync="stock_widget_visible" :before-close="handleClose">
      <div>
        <iframe :src="'https://stocks.tickertape.in/' + stock_code + '?broker=stockants'
          " width="100%" height="400px"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { serverAddr } from "../networkConfig";
import MobileNav from "@/components/MobileNav.vue";
import RecoActionButtons from "@/components/RecoActionButtons.vue";
import MobileFilterDialog from "@/components/MobileFilterDialogDerivatives.vue";
import FilterForDesktopViewDerivatives from "@/components/FilterForDesktopViewDerivatives.vue";
import { HelperNetworkCallBack } from "../mixins/Helper";
import { screenSize } from "../mixins/ScreenSize.js";
import { filterCallBack } from "../mixins/filter";
import { EventBus } from "../eventBus";
import NoDataFound from "@/components/NoDataFound.vue";

import OptionStrategyCard from "@/components/OptionStrategyCard.vue";
import { derivativesApiCall } from "../mixins/DerivativesApi";
import SearchStock from "@/components/SearchStockDerivatives.vue";
import moment from "moment";
import ExcelJS from "exceljs";

export default {
  name: "ExpertsPastStrategyOptions",

  mixins: [
    HelperNetworkCallBack,
    filterCallBack,
    screenSize,
    derivativesApiCall,
  ],

  components: {
    MobileNav,
    "search-stock": SearchStock,
    NoDataFound,
    RecoActionButtons,
    FilterForDesktopViewDerivatives,
    OptionStrategyCard,
    StockFilter: MobileFilterDialog,
  },

  data() {
    return {
      moment: moment,
      nav_title: "Experts Recommendations",
      filter_title: "Experts recommendations",
      filter_obj: {
        company_id_list: [],
        expert_list: [],
      },
      filter_list: [
        {
          title: "Strategy status",
          filter: [
            "Live",
            "Updated",
            // "Closed",
            "Yet to live",
            "Complete",
            "Incomplete",
            "Stop loss triggered",
            "Exit",
          ],
        },
        {
          title: "Strategy Type",
          filter: ["Bearish", "Bullish"],
        },
        // {
        //   title: "Option Type",
        //   filter: ["Indices", "Stocks"],
        // },
      ],
      is_reco_list_loading: true, //loader placeholder
      other_expert_past_reco_list: [],
      stock_list: "",
      sector: "",
      is_scroll_disabled: true,
      page_no: 1,
      number_of_pages: null,
      stock_code: "",
      stock_widget_visible: false,
      campaignId: null,
      notificationData: [],
      activeVideo: "https://youtube-nocookie.com/embed/QkUAhPDy81I",
      videoDialog: false,
      strikeSymbol: "",
      searchIndiceExpiry: "",
      indiceName: "",
      isExcelDataLoading: false,
      exportRecoList: [],
      startDate: null,
      endDate: null,
      publisherPlaData: {},
    };
  },

  mounted() {
    if (localStorage.getItem("publisher_plan_details")) {
      this.publisherPlaData = JSON.parse(
        localStorage.getItem("publisher_plan_details")
      );
    }

    //if params in route then pushed stock id in stock_list
    if (this.$route.query.stock_id) {
      this.stock_list = this.$route.query.stock_id;
    } else if (this.$route.query.user_id) {
      //if response type is company then sent user id in company id list other wise in expert id list
      if (this.$route.query.user == "company") {
        this.filter_obj.company_id_list.push(this.$route.query.user_id);
      } else {
        this.filter_obj.expert_list.push(this.$route.query.user_id);
      }
    } else if (this.$route.query.sector) {
      this.sector = this.$route.query.sector;
    }

    //api called on page load to get experts reco list
    this.getOtherExpertsPastRecoList(this.filter_obj);

    // window.addEventListener('scroll', this.loadMoreStocks());

    //event emitted when searched stock input field is cleared
    EventBus.$on("clearedSearchedStock", () => {
      this.stock_list = "";
      this.page_no = 1;
    });

    EventBus.$on("clearedSelectedFilter", (filter_obj) => {
      this.stock_list = "";
      this.page_no = 1;
      this.other_expert_past_reco_list = [];
      this.scrollToTop();
      this.filter_obj = filter_obj;

      // if user id, stock id or sector in url's query params then on cleared filter pushed them on relative filterobj
      // to get data accordingly
      if (this.$route.query.stock_id) {
        this.stock_list = this.$route.query.stock_id;
      } else if (this.$route.query.user_id) {
        //if response type is company then sent user id in company id list other wise in expert id list
        if (this.$route.query.user == "company") {
          this.filter_obj.company_id_list.push(this.$route.query.user_id);
        } else {
          this.filter_obj.expert_list.push(this.$route.query.user_id);
        }
      } else if (this.$route.query.sector) {
        this.sector = this.$route.query.sector;
      }

      this.getOtherExpertsPastRecoList(this.filter_obj);
    });

    EventBus.$on("emitSelectedFilters", (filter_obj) => {
      this.page_no = 1;
      this.other_expert_past_reco_list = [];
      this.scrollToTop();
      this.filter_obj = filter_obj;
      this.getOtherExpertsPastRecoList(this.filter_obj);
    });

    //event emmited when stock is selected
    //event emmited when stock is selected
    EventBus.$on("selectedStock", (stock) => {
      this.page_no = 1;
      this.stock_list = "";
      this.indiceName = stock.title;
      this.searchIndiceExpiry = stock.expiry;
      this.strikeSymbol = "";

      this.other_expert_past_reco_list = [];
      this.stock_list = stock.id;

      this.scrollToTop(); //scroll to top of list
      this.getOtherExpertsPastRecoList(this.filter_obj);
    });

    //event emmited when strike price is selected
    EventBus.$on("selectedStrike", (strike) => {
      this.page_no = 1;
      this.stock_list = "";
      this.other_expert_past_reco_list = [];

      this.strikeSymbol = strike.symbol;

      this.scrollToTop(); //scroll to top of list

      // if (this.stock_list) {
      this.getOtherExpertsPastRecoList(this.filter_obj);
      // }
    });
  },

  beforeDestroy() {
    EventBus.$off();
    // window.removeEventListener('scroll', this.loadMoreStocks());
    // this.is_scroll_disabled = false;
  },

  methods: {
    getDataForDownloadExcel() {
      this.isExcelDataLoading = true;

      serverAddr
        .get(
          `/options/opinion/my_view_expert_options?from=${this.startDate}&to=${this.endDate
          }`
        )
        .then((response) => {
          if (response.data.status) {
            this.exportRecoList = response.data.data;
            this.downloadExcel();
          } else {
          }
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },
    async downloadExcel() {
      try {
        const outputArray = [];

        this.exportRecoList.forEach((item) => {
          item.data.forEach((element) => {
            outputArray.push({
              "Strategy Date": moment(item.strategy.created_date).format(
                "MMM DD YYYY, hh:mm A"
              ),
              Instrument: element.direction,
              "Lot Size": element.stock.lot_size,
              "Entry Price": element.entry_premium,
              "Strategy Type": item.strategy.tag,
              "Buy/Sell": element.direction,
              Target: element.target_premium,
              "Stop Loss": element.stop_loss,
              "Strategy Status": item.strategy.status,
              "Strategy Status Time Stamp":
                item.strategy.last_event_timestamp != null
                  ? moment(item.strategy.last_event_timestamp).format(
                    "MMM DD YYYY, hh:mm A"
                  )
                  : "-",
              "Strategy Status current price": element.current_price,
              "Target Potential %": element.target_potential,
              "Performance %": element.performance,
              "Remaining potential_as_of_current_date":
                element.remaining_potential_in_rs,
              "Max downside": element.max_loss,
              "Max downside %": element.max_loss_in_percentage,
              "Max upside": element.max_profit,
              "Max upside %": element.max_profit_in_percentage,
              // "Risk Tag": item.strategy.risk_tag,
              "Logic Tags": item.logic,
            });
          });
        });

        // Define headers and their desired order
        const headers = [
          "Strategy Date",
          "Instrument",
          "Lot Size",
          "Entry Price",
          "Strategy Type",
          "Buy/Sell",
          "Target",
          "Stop Loss",
          "Strategy Status",
          "Strategy Status Time Stamp",
          "Strategy Status current price",
          "Target Potential %",
          "Performance %",
          "Remaining potential_as_of_current_date",
          "Max downside",
          "Max downside %",
          "Max upside",
          "Max upside %",
          // "Risk Tag",
          "Logic Tags",
        ];

        // Create a new workbook
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sheet1");

        // Add headers
        worksheet.addRow(headers);

        // Add data to worksheet
        outputArray.forEach((item) => {
          const row = headers.map((header) =>
            item[header] !== undefined ? item[header] : null
          );
          worksheet.addRow(row);
        });

        // Set column widths
        const columnWidths = {
          A: 30,
          B: 20,
          C: 10,
          D: 20,
          E: 15,
          F: 15,
          G: 15,
          H: 30,
          I: 30,
          J: 30,
          K: 20,
          L: 15,
          M: 40,
          N: 15,
          O: 15,
          P: 15,
          Q: 15,
          R: 20,
          S: 30,
          T: 80,
        };

        Object.keys(columnWidths).forEach((column, index) => {
          worksheet.getColumn(index + 1).width = columnWidths[column];
        });

        // Center-align all columns
        worksheet.eachRow((row, rowNumber) => {
          row.eachCell((cell, colNumber) => {
            cell.alignment = { vertical: "middle", horizontal: "center" };
          });
        });

        // Generate Excel file
        const buffer = await workbook.xlsx.writeBuffer();

        // Create Blob
        const blob = new Blob([buffer], { type: "application/octet-stream" });

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Strategy List.xlsx";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        setTimeout(() => {
          this.isExcelDataLoading = false;
        }, 1000);
      } catch (error) {
        setTimeout(() => {
          this.isExcelDataLoading = false;
        }, 1000);
        console.error("Error exporting to Excel:", error);
      }
    },
    videoDialogClose() {
      this.videoDialog = false;
      let video = document.getElementById("videoId");
      let url = video.getAttribute("src");
      video.setAttribute("src", "");
      video.setAttribute("src", url);
    },

    openTradeWidget(stock_code, reco_id) {
      if (KiteConnect) {
        KiteConnect.ready(async function () {
          // Initialize a new Kite instance.
          // You can initialize multiple instances if you need.
          let kite = await new KiteConnect("s8r229rs5vrd6yzn");

          kite.add({
            exchange: "NSE",
            tradingsymbol: stock_code,
            quantity: 1,
            order_type: "LIMIT",
            // "transaction_type": "SELL",
            // "price": 105
          });

          // Register an (optional) callback.
          kite.finished(function (status, request_token) { });

          let id = "#default-button" + reco_id;

          // Render the in-built button inside a given target
          kite.renderButton(id);

          // OR, link the basket to any existing element you want
          // kite.link("#custom-button");
        });
      }
    },

    openStockWidget(stock_code) {
      this.stock_code = stock_code;
      this.stock_widget_visible = true;
    },

    // close stock widget dialog
    handleClose() {
      this.stock_widget_visible = false;
    },

    getRecoByStockName(reco) {
      // if(this.isUserLoggedIn){
      this.stock_list = ""; //cleared previously selected stocks
      // this.filter_obj.expert_list = [];
      // this.filter_obj.company_id_list = [];
      this.stock_list = reco.stock.id;

      this.page_no = 1;
      this.other_expert_past_reco_list = []; //cleared previous results
      this.scrollToTop(); //scroll to top of list
      this.getOtherExpertsPastRecoList(this.filter_obj);
      // }
    },

    getRecoByExpertName(expert) {
      this.filter_obj.expert_list = []; //cleared previously selected experts
      this.filter_obj.company_id_list = []; //cleared previously selected company
      this.stock_list = ""; //cleared previously selected stocks

      if (expert.filtered_by == "company") {
        this.filter_obj.company_id_list.push(expert.user.company.id); //pushed experts profile id
      } else {
        this.filter_obj.expert_list.push(expert.user.user_profile_id); //pushed experts profile id
      }

      this.page_no = 1;
      this.other_expert_past_reco_list = []; //cleared previous results
      this.scrollToTop(); //scroll to top of list
      this.getOtherExpertsPastRecoList(this.filter_obj);
    },

    scrollToTop() {
      var elmnt = document.getElementsByClassName("recoListSection");
      scrollTo(elmnt, 0, 100);
    },

    loadMoreRecommendations() {
      this.page_no = this.page_no + 1;
      this.getOtherExpertsPastRecoList(this.filter_obj);
    },

    //initially called api to get all experts who uploaded reco
    async getOtherExpertsPastRecoList(filter_obj) {
      this.is_reco_list_loading = true;
      // await this.getExpertData(filter_obj);
      await this.getExperStrategytData(filter_obj);
    },

    loadMoreStocks() {
      window.onscroll = () => {
        //checked is window scrolled to bottom
        if (
          window.innerHeight + window.scrollY >= document.body.scrollHeight &&
          this.is_scroll_disabled &&
          this.number_of_pages > this.page_no
        ) {
          // you're at the bottom of the page

          if (
            (!Object.keys(this.subscribedPlanDetails).length ||
              this.subscribedPlanDetails.plan == "Lite") &&
            localStorage.getItem("access_to_expert_dashboard")
          ) {
            if (
              localStorage.getItem("access_to_expert_dashboard") !=
              this.$route.query.user_id
            ) {
              this.stock_rank_board_page_no = 1; //reset to page no 1
              this.$store.commit("commitSubscribPlanDialogVisibility", true);
              return;
            }
          } else if (
            !Object.keys(this.subscribedPlanDetails).length ||
            this.subscribedPlanDetails.plan == "Lite"
          ) {
            this.stock_rank_board_page_no = 1; //reset to page no 1
            this.$store.commit("commitSubscribPlanDialogVisibility", true);
            return;
          }

          this.page_no = this.page_no + 1;
          this.getOtherExpertsPastRecoList(this.filter_obj);
          this.is_scroll_disabled = false; //disabled scroll to avoid many time function call
        }
      };
    },
  },

  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },

    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem("plan_details"));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.PastStrategyOptions {
  // min-height: 100vh;
  background-color: $page-background-color;
  padding: 60px 0 0 0 !important;

  .search-container {
    box-sizing: border-box;
    position: fixed;
    width: calc(100% - 282px);
    margin-left: 282px;
    padding: 0px 10px 0px 10px;
    background-color: #ffff;
    z-index: 1;
    box-shadow: 0px -2px 14px 0px #d6d6d6;
  }

  .search-stock-section {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    background-color: #ffff;
    padding: 15px 20px 15px 0px;
    width: 100%;
  }

  .export-btn {
    font-size: 12px;
    padding: 4px 10px;
    margin-left: 8px;
  }

  .filter-icon {
    border: 1px solid #ecf4ff;
    padding: 7px;
    display: flex;
    align-items: center;
    background: #ecf4ff;
    justify-content: center;
    border-radius: 4px;
  }

  .recoListSection {
    box-sizing: border-box;
    width: calc(100% - 285px);
    margin-left: 285px;
    padding: 0 10px;
    min-height: calc(100vh - 60px);
  }

  .footer-section {
    width: calc(100% - 285px);
    margin-left: 285px;
  }

  .more-info-section {
    text-align: center;
    margin: 10px 0;
  }

  .stock-data-section {
    padding: 70px 0px 0 !important;
  }

  .btn-gradient {
    background-image: linear-gradient(to left, #dc6250, #eb5151);
    margin: 10px 0 30px;
    width: 220px;
    outline: none;
    border-radius: 25px;
    height: 40px;
    color: #fff;
    font-size: 14px;
    border: none;
    cursor: pointer;
  }

  .btn-gradient:hover {
    transition: 0.4s ease;
    box-shadow: 0px 0px 10px -1px #dc6250;
  }

  .plan-notification-dialog {
    .el-dialog {
      width: 40%;
      border-radius: 10px;
    }
  }

}

//media queries
@media screen and (max-width: 1283px) {
  .PastStrategyOptions {
    padding: 50px 0 80px 0;

    .recoListSection {
      width: 100%;
      margin-left: 0;
    }

    .footer-section {
      width: 100%;
      margin-left: 0;
    }

    .search-container {
      width: 100%;
      margin-left: 0;
      padding: 0;
    }

    .search-stock-section {
      padding: 10px 10px 10px 10px;
    }

    .action-btn-component {
      display: flex;
      justify-content: center;
      margin: 10px 0;
    }

    .desktopFilterSection {
      display: none;
    }
  }
}

@media screen and (max-width: 850px) {
  .PastStrategyOptions {
    .plan-notification-dialog {
      .el-dialog {
        width: 94%;
      }
    }

  }
}

@media screen and (max-width: 600px) {
  .PastStrategyOptions {
    .recoListSection {
      padding: 0;
    }
    .stock-data-section {
      padding: 100px 0px 0 !important;
    }

  }

}
</style>
<style lang="scss">
@media screen and (max-width: 600px) {
  .PastStrategyOptions {
    .search-stock-section {
      flex-wrap: wrap;
    }

    .export-section {
      width: 100%;
      justify-content: end;
      margin-top: 10px;
    }

    .SearchStock .strike-price-search-stock-container {
      width: 117px !important;
    }

    .strike-price-seach-input {
      margin-left: 5px;
    }
  }

}
</style>
